import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, Share2 } from "lucide-react";

export default function LandedRefunds({ refunds, onShare }) {
  const landed = refunds.filter((r) => r.stage === "landed").slice(0, 6);
  if (landed.length === 0) return null;
  const total = landed.reduce((s, r) => s + r.amount, 0);
  return (
    <Card className="tactile-card rounded-md p-5" data-testid="landed-refunds">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#00E676]">RECOVERED · SHAREABLE</div>
          <h3 className="font-display text-lg font-bold tracking-tight">
            ${total.toFixed(2)} clawed back
          </h3>
        </div>
        <span className="font-mono text-[10px] uppercase tracking-widest text-[#606872]">tap share on any win</span>
      </div>
      <div className="grid sm:grid-cols-2 gap-2">
        {landed.map((r) => (
          <div
            key={r.id}
            className="flex items-center justify-between px-3 py-2.5 rounded-md bg-[#0C0D0E] border border-[#282C30]"
            data-testid={`landed-refund-${r.id}`}
          >
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <Check className="h-3.5 w-3.5 text-[#00E676] shrink-0" />
                <span className="font-display font-bold text-sm truncate">{r.merchant}</span>
              </div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-[#606872] mt-0.5 ml-5">
                +${r.amount.toFixed(2)} · {r.channel.replace(/_/g, " ")}
              </div>
            </div>
            <Button
              size="sm"
              variant="outline"
              onClick={() => onShare(r)}
              className="btn-outline-paper h-8 shrink-0"
              data-testid={`share-refund-${r.id}`}
            >
              <Share2 className="h-3.5 w-3.5 mr-1" /> Share
            </Button>
          </div>
        ))}
      </div>
    </Card>
  );
}
